
const mutationTypes = Object.freeze({
    NAME: 'NAME',
    CODE: 'CODE',
});
export default mutationTypes;